module.exports = __webpack_public_path__ + "static/media/BoxPlotMCQ2_1.b973c81b.svg";